import { JobStatus } from "../schedulerTypes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { StandardChip, Placement } from "../../../../../../shared/components/badges/StandardChip"
import React from "react"

export function JobStatusBadge({ status, placement }: { status?: JobStatus; placement?: Placement }) {
    const { l10n } = useAppLocalization()

    switch (status) {
        case "ACTIVE":
            return (
                <StandardChip
                    placement={placement}
                    label={l10n.getString("support-reports-health-scheduler-table-status-active")}
                    variant="success"
                />
            )

        case "INACTIVE":
            return (
                <StandardChip
                    placement={placement}
                    label={l10n.getString("support-reports-health-scheduler-table-status-inactive")}
                    variant="red"
                />
            )

        case "PAUSED":
            return (
                <StandardChip
                    placement={placement}
                    label={l10n.getString("support-reports-health-scheduler-table-status-paused")}
                    variant="grey"
                />
            )

        default:
            return <></>
    }
}
